import getKey from './get-key';
const createPathBreadcrumb = (path) => {
    return (path
        .split(getKey.regexp)
        .filter(Boolean)
        .map((p) => (p === '[]' ? '[0]' : p)));
};
export default createPathBreadcrumb;
//# sourceMappingURL=create-path-breadcrumb.js.map